import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { useDispatch } from 'react-redux'

import PageHeader from '../common/PageHeader/PageHeader'
import { setCurrentTab } from '../../actions/commonActions'

import classes from './EnrollmentsBillingLayout.module.scss'

const EnrollmentsBillingLayout = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setCurrentTab('Enrollments & Billing'))
  }, [dispatch])

  return (
    <div id='enrollmentsBillingLayout' className={classes.layout}>
      <PageHeader title='Enrollments & Billing' />
      <Outlet />
    </div>
  )
}

export default EnrollmentsBillingLayout
